import Vue from 'vue'

const padStart = function padStart (value, length, char) {
  value = value + ''
  const len = length - value.length
  if (len <= 0) {
    return value
  } else {
    return Array(len + 1).join(char) + value
  }
}

// 时区校正
/* const revise = function () {
  return (parseInt(new Date().getTimezoneOffset() / 60) * -1) * 3600
} */

Vue.filter('dateFormat', function (date, format) {
 // const newDate = +new Date(date) - revise()
  if (!date) {
    return ''
  }
  format = format || 'YYYY年MM月DD日 hh时mm分ss秒'
  const _date = new Date(date)
  const splitArr = format.split(format.indexOf('YYYY') > -1 ? /(YYYY|MM|DD|hh|mm|ss)+/ : /(YY|MM|DD|hh|mm|ss)+/)
  return splitArr.map(function (item) {
    if (item === 'YYYY') {
      return _date.getFullYear()
    }
    if (item === 'YY') {
      return _date.getFullYear().toString().slice(2)
    }
    if (item === 'MM') {
      return padStart(_date.getMonth() + 1, 2, 0)
    }
    if (item === 'DD') {
      return padStart(_date.getDate(), 2, 0)
    }
    if (item === 'hh') {
      return padStart(_date.getHours(), 2, 0)
    }
    if (item === 'mm') {
      return padStart(_date.getMinutes(), 2, 0)
    }
    if (item === 'ss') {
      return padStart(_date.getSeconds(), 2, 0)
    }
    return item
  }).join('')
})

Vue.filter('expireDay', function (second, isFloor) {
  second = Math.abs(second)
  const f = isFloor ? Math.floor : Math.ceil
  const d = f(second/ 60/ 60 / 24)
  if (!d) {
    return '0天'
  }
  return (d > 1 ? d : 1) + '天'
})

Vue.filter('freeTime', function (second) {
  const h = Math.floor(second / 60 / 60)
  const m = Math[h >= 1 ? 'floor' : 'ceil'](second / 60 % 60) 
  return second > 60 ? (h ? h + '小时' : '') + (m ? m + '分钟' : '') : (second > 0 ? '小于1分钟' : '0小时0分钟')
})

Vue.filter('playingTime', function (second) {
  const diff = second
  const h = Math.floor(diff / 3600)
  const m = Math.floor((diff / 60 % 60))
  const s = Math.ceil((diff % 60))
  return padStart(h, 2, 0) + ":" + padStart(m, 2, 0) + ":" + padStart(s, 2 , 0)
})

Vue.filter('queueTime', function (num, time) {
  return Math.ceil(+num / +time)
})

Vue.filter('removeZero', function (num) {
  return window.parseFloat(num)
})

Vue.filter('secondFormate', function (second) {
  const m = parseInt(second / 60)
  const s = second % 60
  return (m ? padStart(m, 2, 0) +  '分' : '') + (s ? padStart(s, 2, 0) + '秒' : '')
})

Vue.filter('coinsHour', function (perMinute) {
  return parseInt(perMinute * 60)
})

